import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  data() {
    return {
      sourceId: '',
      voIPRtilCode: '',
      VoIPStatus: 0 // 0: not connect 1: conncting 2: connected
    };
  },

  props: {
    selectRid: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    rtilCode: {
      default: ''
    },
    nickName: {
      type: [String, Number],
      default: ''
    },
    memberId: {
      default: ''
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      Webrtc: state => state.webrtc
    }),
    VoIPStatusClass() {
      let _str = '';
      switch (this.VoIPStatus) {
        case 0:
          _str = 'icon-dadianhua1';
          break;
        case 1:
          _str = 'icon-connecting';
          break;
        case 2:
          _str = 'icon-dadianhua1 connected';
          break;
      }
      return _str;
    }
  },
  created() {
    Bus.$on('notify', v => {
      const {
        key,
        rtilCode
      } = v;
      if (key === 'asyncHost' && rtilCode == this.rtilCode) {
        this.VoIPStatus = 2;
        let voipStatusInfo = handleLocalStorage('get', 'voipStatus');
        if (voipStatusInfo) {
          voipStatusInfo = JSON.parse(voipStatusInfo);
          voipStatusInfo[rtilCode] = {
            rtilCode,
            status: 2
          };
          handleLocalStorage('set', 'voipStatus', voipStatusInfo);
        }
      }
    });
  },
  mounted() {
    let voipStatusInfo = handleLocalStorage('get', 'voipStatus');
    if (voipStatusInfo && voipStatusInfo != '{}' && JSON.parse(voipStatusInfo)[this.rtilCode]) {
      voipStatusInfo = JSON.parse(voipStatusInfo);
      this.VoIPStatus = this.rtilCode ? voipStatusInfo[this.rtilCode].status : 0;
    }
  },
  methods: {
    changeSourceId(val) {
      this.sourceId = val;
    },
    changeVoIPStatus(val) {
      this.VoIPStatus = val;
    },
    configVoIP() {
      // 判断是否为host，只有host才能停止VoIP
      if (!this.userInfo.owner) return;
      if (this.VoIPStatus) {
        this.sendStopVoIP();
      } else {
        this.sendStartVoIP();
      }
    },
    sendStartVoIP() {
      const params = {
        rid: this.selectRid,
        sourceId: this.rtilCode,
        sourceType: 'rtil',
        partyCode: this.State.partyCode,
        rtilCode: this.rtilCode,
        memberId: this.memberId,
        sourceName: this.nickName ? `PL_${this.nickName}_${this.rtilCode}_${this.State.partyCode}` : `${this.rtilCode}_${this.State.partyCode}`,
        needAudio: true
      };
      this.axios.post('/partyline-backend/receiver/startVoIP', params).then(res => {
        // 把 VoIP 的状态存到本地
        let voipStatusInfo = handleLocalStorage('get', 'voipStatus');
        if (voipStatusInfo) {
          voipStatusInfo = JSON.parse(voipStatusInfo);
          voipStatusInfo[this.rtilCode] = {
            rtilCode: this.rtilCode,
            status: 1
          };
          handleLocalStorage('set', 'voipStatus', voipStatusInfo);
        } else {
          const obj = {};
          obj[this.rtilCode] = {
            rtilCode: this.rtilCode,
            status: 1
          };
          handleLocalStorage('set', 'voipStatus', obj);
        }
      });
    },
    sendStopVoIP() {
      const params = {
        rtilCode: this.rtilCode,
        partyCode: this.State.partyCode
      };
      this.axios.post('/partyline-backend/receiver/stopVoIP', params).then(res => {
        let voipStatusInfo = handleLocalStorage('get', 'voipStatus');
        if (voipStatusInfo) {
          voipStatusInfo = JSON.parse(voipStatusInfo);
          this.$delete(voipStatusInfo, this.rtilCode);
          handleLocalStorage('set', 'voipStatus', voipStatusInfo);
        }
      });
    },
    startVoIP() {
      if (!this.selectRid) {
        this.$message.error('Operation failed, please select Receiver first.');
        return;
      }
      this.VoIPStatus = 1;
      this.Webrtc.startCall([`0x${this.selectRid.toUpperCase()}`], {
        type: 'audio'
      }, info => {
        const type = info.type;
        if (type === 'success') {
          this.VoIPStatus = 2;
          if (this.$refs.voipAudio) {
            this.$refs.voipAudio.srcObject = info.msg.mediaStream;
          }
          // 判断当前是否是host,与会者需要发给host同步状态
          if (!this.userInfo.owner) {
            this.sendResultToHost();
          } else {
            let voipStatusInfo = handleLocalStorage('get', 'voipStatus');
            if (voipStatusInfo) {
              voipStatusInfo = JSON.parse(voipStatusInfo);
              voipStatusInfo[this.rtilCode] = {
                rtilCode: this.rtilCode,
                status: 2
              };
              handleLocalStorage('set', 'voipStatus', voipStatusInfo);
            }
          }
        } else if (type === 'userNotExists') {
          this.$message.error('Current user does not exist');
        }
      });
    },
    stopVoIP() {
      this.VoIPStatus = 0;
      this.Webrtc.stopCall([`0x${this.selectRid.toUpperCase()}`], true);
    },
    sendResultToHost() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'asyncHost',
          rtilCode: this.rtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=95582', params).then(async res => {});
    }
  }
};